import React from "react";
import PropTypes from "prop-types";
import MuiDialogTitle from "@mui/material/DialogTitle";
import { Dialog, DialogActions } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export const DeleteMachineStatusDialog = ({
  dialog,
  setDialog,
  onConfirmDelete
}) => {
  return (
    <Dialog
      maxWidth="sm"
      open={dialog}
      aria-label="Machine status log delete dialog"
    >
      <MuiDialogTitle>
        <Typography>
          Are you sure you want to delete this status log?
        </Typography>
      </MuiDialogTitle>

      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setDialog(false)}
          data-qa="CP-Button-Cancel-Delete"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirmDelete}
          data-qa="CP-Button-Confirm-Delete"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteMachineStatusDialog.propTypes = {
  dialog: PropTypes.bool,
  setDialog: PropTypes.func,
  onConfirmDelete: PropTypes.func
};
